<template>
  <div @click="setIsMapOpen" id="mapBtn" class="mob-map-btn">
    <div class="mob-map-btn__wrap">
      <svg>
        <use :xlink:href="isMapOpen ? '#list-light' : '#map-light'"></use>
      </svg>
      {{ isMapOpen ? "List" : "Map" }}
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "MobMabBtn",
  computed: {
    ...mapState("map", ["isMapOpen"]),
  },
  methods: {
    ...mapMutations("map", ["setIsMapOpen"]),
  },
};
</script>
